import { render } from "./TriggerButton.vue?vue&type=template&id=d442e1b4"
import script from "./TriggerButton.vue?vue&type=script&lang=js"
export * from "./TriggerButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__